"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.5.2'] && _();
}
catch (e) { }
